import React from 'react';
import SelectableList from '../common/selectable_list';

const ControlsMenuList = React.createClass({

  render: function() {
    return (
    	<SelectableList
        tagName="ul"
        className="abl-nav-menu-list"
        selectedClass="abl-selected"
        items={this.props.items}
        itemTemplate={this._itemTemplate}
        onChange={this.props.onChange}
        toggleSelect={true} />
    );
  },

  _itemTemplate: function(item, handleClick) {
    return (
      <li>
        <a onClick={handleClick} title={item.name}>
          <img src={item.imgSrc} height={item.height} width={item.width} alt={item.name} />{item.name}
          <span></span>
        </a>
        <div className="abl-tray">
          <a 
            className="abl-controls-menu-clear-all" 
            onClick={this.props.onClearAllClick.bind(null, item.id)}>Clear All</a>
          {this._renderTray(item)}
        </div>
      </li>
    );
  },

  _renderTray: function(item) {
    let tray = null;
    React.Children.forEach(this.props.children, (child) => {
      if(child.props.id === item.id) {
        tray = child;
      }
    });

    return tray;
  }

});

export default ControlsMenuList;


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/controls_menu_list.js
 **/